import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { EMPTY, expand, forkJoin, map, Observable, reduce } from 'rxjs'
import { environment } from '../../../../environments/environment'

export type RoleUser = { id: string; name: string }

type UsersByRolePage = {
  users: { externalId: string; name: string }[]
  nextPageToken?: string
}

const PAGE_SIZE = 200

@Injectable({
  providedIn: 'root'
})
export class KanbanUsersByRoleService {
  private http = inject(HttpClient)

  getUsersByRoles(roleIds: string[]): Observable<RoleUser[]> {
    return forkJoin(roleIds.map(roleId => this.getAllPages(roleId))).pipe(
      map(pages => pages.flat())
    )
  }

  private getAllPages(roleId: string): Observable<RoleUser[]> {
    return this.getPage(roleId).pipe(
      expand(page => (page.nextPageToken ? this.getPage(roleId, page.nextPageToken) : EMPTY)),
      reduce<UsersByRolePage, UsersByRolePage['users']>(
        (acc, page) => [...acc, ...page.users],
        []
      ),
      map(users => users.map(u => ({ id: u.externalId, name: u.name })))
    )
  }

  private getPage(roleId: string, pageToken?: string): Observable<UsersByRolePage> {
    return this.http.get<UsersByRolePage>(`${environment.permissionsApiUrl}/users/v1/`, {
      params: pageToken
        ? { role_id: roleId, page_size: PAGE_SIZE, page_token: pageToken }
        : { role_id: roleId, page_size: PAGE_SIZE }
    })
  }
}
